import Papa from 'papaparse';
import { IImportCsvConfig } from './ImportProvider';
import { removeNonUTF8ASCII } from 'src/domain/stringCleaner';

export type ParsedRecord<T extends string> = Record<
    T,
    { value: any; parsedValue: any | undefined | string | number | boolean; error?: string; warning?: string }
>;

export async function parseCsv<T extends string>(
    content: string,
    csvConfig: Readonly<IImportCsvConfig[]>,
    skipHeaderRows: number, // how many rows (headers) to skip
    parser: (row: ParsedRecord<T>) => ParsedRecord<T>
): Promise<ParsedRecord<T>[]> {
    const data = await csvToJs(content);
    if (!data?.length) return [];

    // todo: validate headers!

    /** remove header rows */
    data.splice(0, skipHeaderRows);

    let records: ParsedRecord<T>[] = [];
    data.forEach(row => {
        const record = {} as ParsedRecord<T>;

        csvConfig.forEach((col, index) => {
            record[col.column as T] = {
                value: removeNonUTF8ASCII(row[index]),
                parsedValue: undefined,
                error: undefined,
                warning: undefined,
            };
        });

        records.push(record);
    });

    records = records.map(record => {
        return parser(record);
    });

    return records;
}

async function csvToJs(content: string): Promise<string[][]> {
    return new Promise((resolve, reject) => {
        Papa.parse<string[]>(content, {
            // we do not convert types automatically (because of some issues),
            // we handle it manually from string
            dynamicTyping: false,
            skipEmptyLines: true,
            transform: (item: string, index: number) => {
                return item.trim();
            },
            complete: async results => {
                return resolve(results.data);
            },
        });
    });
}
